type Window = typeof window;

export const CONFIG_KEY = 'UW_CONFIG' as keyof Window;

export const VERSION = window?.[CONFIG_KEY]?.VERSION ?? process.env.VERSION;
export const QP_QUERY_URI = window?.[CONFIG_KEY]?.QP_QUERY_URI;
export const BANK_TOKEN_URL = window?.[CONFIG_KEY]?.BANK_TOKEN_URL;

export const PARTNER_PRESENTATION_URL =
  window?.[CONFIG_KEY]?.PARTNER_PRESENTATION_URL;

export const ONETRUST_KEY = window?.[CONFIG_KEY]?.ONETRUST_KEY;
export const ONETRUST_ENABLED =
  window?.[CONFIG_KEY]?.ONETRUST_ENABLED === 'true';
export const SPREEDLY_ENVIRONMENT_KEY =
  window?.[CONFIG_KEY]?.SPREEDLY_ENVIRONMENT_KEY;
export const SPREEDLY_ENV = window?.[CONFIG_KEY]?.SPREEDLY_ENV || 'Dev';
export const OPTIMIZELY_SDK_KEY = window?.[CONFIG_KEY]?.OPTIMIZELY_SDK_KEY;
export const OPTIMIZELY_WEB_ENABLED =
  window?.[CONFIG_KEY]?.OPTIMIZELY_WEB_ENABLED === 'true';
export const SNOWPLOW_COLLECTOR_URL =
  window?.[CONFIG_KEY]?.SNOWPLOW_COLLECTOR_URL;
export const OTEL_COLLECTOR_URL = window?.[CONFIG_KEY]?.OTEL_COLLECTOR_URL;
export const GTM_KEY = window?.[CONFIG_KEY]?.GTM_KEY;
export const OBSERVABILITY_ENV = window?.[CONFIG_KEY]?.OBSERVABILITY_ENV;
export const SENTRY_ENV = window?.[CONFIG_KEY]?.SENTRY_ENV;
export const MIXPANEL_REPLAYS_TOKEN =
  window?.[CONFIG_KEY]?.MIXPANEL_REPLAYS_TOKEN;
export const OKTA_CLIENT_ID = window?.[CONFIG_KEY]?.OKTA_CLIENT_ID;
export const OKTA_ISSUER_URL = window?.[CONFIG_KEY]?.OKTA_ISSUER_URL;
export const OKTA_CLIENT_ID_INTERNAL =
  window?.[CONFIG_KEY]?.OKTA_CLIENT_ID_INTERNAL;
export const OKTA_ISSUER_URL_INTERNAL =
  window?.[CONFIG_KEY]?.OKTA_ISSUER_URL_INTERNAL;
export const OKTA_LOGIN_TYPE = window?.[CONFIG_KEY]?.OKTA_LOGIN_TYPE;
export const SENTRY_DSN = window?.[CONFIG_KEY]?.SENTRY_DSN;
export const CONFIGCAT_SDK_KEY = window?.[CONFIG_KEY]?.CONFIGCAT_SDK_KEY;
export const PARTNER_APP_MIN_VERSION_FOR_AUTH =
  window?.[CONFIG_KEY]?.PARTNER_APP_MIN_VERSION_FOR_AUTH ?? '2.21.0';
export const GTM_GATEWAY_SRC = window?.[CONFIG_KEY]?.GTM_GATEWAY_SRC;
export const SNOWPLOW_IN_LIFE_TRACKER_NAMESPACE =
  window?.[CONFIG_KEY]?.SNOWPLOW_IN_LIFE_TRACKER_NAMESPACE;
